export enum EInfoType {
  COUNTRY = 1,
  REGION,
  CITY,
  ATTRACTION,
  ERROR,
  TRIP
}
